<template>
  <div v-loading="loading">
    <div class="edit LevelSloganConfig">
      <el-row>
        <el-col style="width: 85px; line-height: 38px;">星级标语：</el-col>
        <el-col :span="20">
          <el-form
            ref="editList"
            :model="formData"
            label-width="50px"
            class="demo-dynamic">
            <el-form-item
              v-for="(item, index) in formData.editList"
              :label="`${index + 1}星`"
              :key="index"
              :error="listErrors[index]"
            >
              <el-tag
                v-for="tag in item"
                :key="tag"
                :disable-transitions="false"
                closable
                @close="handleClose(item, tag)">
                {{ tag }}
              </el-tag>
              <el-input
                v-if="inputVisibleList[index].inputVisible"
                ref="saveTagInput"
                v-model="inputValue"
                :class="['input-new-tag', `saveTagInput${index}`]"
                type="text"
                maxlength="50"
                show-word-limit
                placeholder="请输入内容"
                size="small"
                @keyup.enter.native="handleInputConfirm(index)"
                @blur="handleInputConfirm(index)"
              />
              <el-button
                v-else
                class="button-new-tag"
                size="small"
                @click="showInput(index)">+ 添加标语</el-button>
              <el-button
                v-if="(index+1) === formData.editList.length"
                class="del button-new-tag"
                @click.prevent="removeDomain(item)">删除</el-button>
            </el-form-item>
            <el-form-item class="btn">
              <el-button @click="addDomain">新增星级</el-button>
              <el-button
                type="primary"
                @click="submitForm()">提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { $http } from "@/utils";

export default {
  name: "LevelSloganConfig",
  data() {
    return {
      loading: true,
      formData: {
        editList: [],
      },
      listErrors: [],
      inputVisibleList: [],
      inputVisible: false,
      inputValue: "",
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      $http.get("/config/study_report_level_tag", {})
        .then((res) => {
          this.formData.editList = res.data;
          this.inputVisibleList = res.data.map(item => ({ inputVisible: false }));
          this.loading = false;
        })
        .catch((err) => {
          this.$notify.error({
            title: "错误",
            message: err.message,
          });
          this.loading = false;
        });
    },
    submitForm() {
      const check = this.formData.editList.map(item => item.length);
      if (check.indexOf(0) !== -1) {
        this.$alert("请添加星级标语!");
      } else {
        this.loading = true;
        const data = {
          value: this.formData.editList,
        };
        $http.put("/config/study_report_level_tag", data)
          .then((res) => {
            this.$notify({
              title: "成功",
              message: "提交成功",
              type: "success",
            });
            this.load();
          })
          .catch((err) => {
            this.$notify.error({
              title: "错误",
              message: err.message,
            });
            this.loading = false;
          }); 1;
      }
    },
    removeDomain(item) {
      const index = this.formData.editList.indexOf(item);
      this.$confirm("是否删除该星级标语？").then(() => {
        if (index !== -1) {
          this.formData.editList.splice(index, 1);
          this.inputVisibleList.splice(index, 1);
        }
      });
    },
    addDomain() {
      this.formData.editList.push([]);
      this.inputVisibleList.push({ inputVisible: false });
    },
    handleClose(item, tag) {
      item.splice(item.indexOf(tag), 1);
    },
    showInput(index) {
      this.inputVisibleList[index].inputVisible = true;
      this.$nextTick((_) => {
        const dom = document.querySelector(`.saveTagInput${index} input`);
        dom.focus();
      });
    },
    handleInputConfirm(index) {
      if (this.inputValue) {
        this.formData.editList[index].push(this.inputValue);
      }
      this.inputVisibleList[index].inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>

<style scoped>
.edit .el-input{
    width: 100px;
    margin: 0 10px;
}
.edit .del{
    margin: 0 10px;
}
</style>
<style>
.LevelSloganConfig .edit .btn .el-form-item__content{
    margin-left: 0 !important;
}
.LevelSloganConfig .el-tag{
    margin-bottom: 10px;
}
.LevelSloganConfig .el-tag + .el-tag {
    margin-left: 10px;
}
.LevelSloganConfig .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.LevelSloganConfig .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
.LevelSloganConfig .el-input__inner {
    vertical-align: top !important;
}
.LevelSloganConfig .el-form-item__content{
    flex-wrap: wrap;
}
</style>
